import React from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Command, Lightbulb } from "lucide-react";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

const AddOptionDialog = ({ open, onClose, onWidgetSelect, onDeviceSelect }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleWidgetSelect = () => {
    onWidgetSelect();
    onClose();
  };

  const handleDeviceSelect = () => {
    onDeviceSelect();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" component="div">
          Add New Card
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2, pb: 3 }}>
        <Grid container spacing={2} direction="column">
          <Grid item xs={12}>
            <Card
              elevation={0}
              sx={{
                cursor: "pointer",
                height: "80px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "action.hover",
                  borderColor: "#bdbdbd",
                },
                "&:active": {
                  bgcolor: "action.selected",
                },
              }}
              onClick={handleWidgetSelect}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 2,
                  px: 3,
                }}
              >
                <Command
                  size={32}
                  style={{
                    color: theme.palette.primary.main,
                  }}
                />
                <Typography variant="h6">New Widget Card</Typography>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card
              elevation={0}
              sx={{
                cursor: "pointer",
                height: "80px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "action.hover",
                  borderColor: "#bdbdbd",
                },
                "&:active": {
                  bgcolor: "action.selected",
                },
              }}
              onClick={handleDeviceSelect}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 2,
                  px: 3,
                }}
              >
                <Lightbulb
                  size={32}
                  style={{
                    color: theme.palette.primary.main,
                  }}
                />
                <Typography variant="h6">New Device Card</Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AddOptionDialog;
